"use client";
import React, { useRef, useState } from "react";

export default function FaqFullPage({ data }) {
    const questionRefs = useRef([]);
    const answerRefs = useRef([]);
    const [openIndex, setOpenIndex] = useState(null);


    const toggleAccordions = (i) => {
        setOpenIndex(openIndex === i ? null : i);

        if (questionRefs.current[i].classList.contains("active")) {
            questionRefs.current[i].classList.remove("active");
            const element = answerRefs.current[i];
            element.style.height = "0px";
            element.style.overflow = "hidden";
            element.style.transition = "all 0.5s ease-in-out";
            element.style.marginBottom = "0px";
        } else {
            questionRefs.current[i].classList.add("active");

            const element = answerRefs.current[i];
            element.style.height = element.scrollHeight + "px";
            element.style.overflow = "hidden";
            element.style.transition = "all 0.5s ease-in-out";
            element.style.marginBottom = "1.55em";
        }
    };

    return (
        <>
            <div className="row mb-30">
                <h2 className="text-2xl font-semibold mb-9">Frequently Asked Questions</h2>
            </div>
            <dl className="toggle" style={{ border: "none" }}>
                {data?.map((item, index) => (
                    <React.Fragment key={index}>
                        <dt
                            onClick={() => {
                                toggleAccordions(index);
                            }}
                            className="cursor-pointer text-md font-semibold flex items-center space-x-2 pt-1"
                        >
                            <div style={{ display: "grid", gridTemplateColumns: "repeat(6, minmax(0, 1fr))", gap: "1rem" }}>
                                <div style={{ gridColumnStart: 1, gridColumnEnd: 6 }}> <span
                                    className={`transform transition-transform duration-300 absolute right-0  ${openIndex === index ? 'rotate-180' : ''}`}
                                >
                                    <h3 ref={(el) => (questionRefs.current[index] = el)} style={{ fontSize: "20px", marginBottom: '0px', marginTop:'0px' }}>{item.question}</h3>
                                </span>
                                </div>
                                <div style={{ gridColumnStart: 7, }}> <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                    width={30}
                                    height={30}
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                                        clipRule="evenodd"
                                    />
                                </svg></div>
                            </div>
                        </dt>
                        <dd
                            ref={(el) => (answerRefs.current[index] = el)}
                            className="black faqAnswer mb-0"
                            style={{
                                height: "0px",
                                overflow: "hidden",
                                marginBottom: "0px",
                                fontSize: "20px",
                                transition: "all 0.5s ease-in-out",
                            }}
                        >
                            {item.answer}
                        </dd>
                        <hr className="border-1 border-black" />
                    </React.Fragment>
                ))}
            </dl>
        </>
    );
}